import { MotivosPausa, StatusAgente } from 'models/types'
import { TYPES } from './types'

export const toggleToken = () => ({
  type: TYPES.TOGGLE_TOKEN
})

export const setToken = (value: string) => ({
  type: TYPES.SET_TOKEN,
  value
})

export const cleanToken = () => ({
  type: TYPES.CLEAN_TOKEN
})

export const atualizaTokenSaga = () => ({
  type: TYPES.ATUALIZA_TOKEN_SAGA
})

export const visualizaToken = () => ({
  type: TYPES.SET_VISUALIZACAO_TOKEN
})

export const setNomeUsuario = (value: string) => ({
  type: TYPES.SET_NOME_USUARIO,
  value
})

export const setUsuarioSelected = (value: string) => ({
  type: TYPES.SET_USUARIO_SELECTED,
  value
})

export const cleanUsuarioSelected = () => ({
  type: TYPES.CLEAN_USUARIO_SELECTED
})

export const getUsuariosInstituicaoSaga = () => ({
  type: TYPES.GET_USUARIOS_INSTITUICAO_SAGA
})

export const setUsuariosInstituicao = (value: string[]) => ({
  type: TYPES.SET_USUARIOS_INSTITUICAO,
  value
})
export const toggleModalAssociarDesassociar = (value: boolean) => ({
  type: TYPES.TOGGLE_MODAL_ASSOCIAR_DESASSOCIAR,
  value
})
export const setAcaoModalAssociarDesassociar = (
  value: 'associar' | 'desassociar'
) => ({
  type: TYPES.SET_ACAO_MODAL_ASSOCIAR_DESASSOCIAR,
  value
})
export function confirmarAcaoAssociarDesassociarSaga() {
  return {
    type: TYPES.CONFIRMAR_ACAO_ASSOCIAR_DESASSOCIAR_SAGA
  }
}
export const setRamalAssociado = (value: string) => ({
  type: TYPES.SET_RAMAL_ASSOCIADO,
  value
})
export const getRamalAssociadoSaga = () => ({
  type: TYPES.GET_RAMAL_ASSOCIADO_SAGA
})
export const setStatusAgente = (value: string) => ({
  type: TYPES.SET_STATUS_AGENTE,
  value
})
export const getStatusAgenteSaga = () => ({
  type: TYPES.GET_STATUS_AGENTE_SAGA
})
export const setAcaoModalPausarAgente = (value: 'pausar' | 'despausar') => ({
  type: TYPES.SET_ACAO_MODAL_PAUSAR_AGENTE,
  value
})
export function confirmarAcaoPausarAgenteSaga() {
  return {
    type: TYPES.CONFIRMAR_ACAO_PAUSAR_AGENTE_SAGA
  }
}
export const toggleModalPausarAgente = (value: boolean) => ({
  type: TYPES.TOGGLE_MODAL_PAUSAR_AGENTE,
  value
})

export const getMotivosPausaSaga = () => ({
  type: TYPES.GET_MOTIVOS_PAUSA_SAGA
})
export const setMotivosPausas = (value: MotivosPausa[]) => ({
  type: TYPES.SET_MOTIVOS_PAUSA,
  value
})

export const setMotivoPausaId = (value: string) => ({
  type: TYPES.SET_MOTIVO_PAUSA_ID,
  value
})

export const setStatusAgenteCronometro = (value: StatusAgente) => ({
  type: TYPES.SET_STATUS_AGENTE_CRONOMETRO,
  value
})

export const despausarAgenteSaga = () => ({
  type: TYPES.DESPAUSAR_AGENTE_SAGA
})

export const cleanMotivosPausa = () => ({
  type: TYPES.CLEAN_MOTIVOS_PAUSA
})
